import React from "react";
import { formatCurrency } from "../../../shared/helpers";
import warning from '../../../assets/icons/info.svg';

export const ConfirmationDialog = ({ existingData, newData, onSum, onOverwrite, onCancel }) => {
    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    // Encontrar el mes seleccionado
    const selectedMonth = Object.keys(newData).find(month =>
        Object.keys(newData[month]).length > 0
    );

    // Encontrar todos los meses que tienen datos
      const getRelevantMonths = () => {
        // Obtener todos los meses donde hay datos existentes
        const existingMonths = Object.keys(existingData || {});
        
        // Obtener todos los meses donde hay nuevos datos
        const newMonths = Object.keys(newData || {});
        
        // Combinar y convertir a números
        const allMonths = [...new Set([...existingMonths, ...newMonths])]
            .map(Number)
            .filter(month => {
                const hasExistingData = existingData[month] && 
                    Object.keys(existingData[month]).length > 0;
                const hasNewData = newData[month] && 
                    Object.values(newData[month]).some(amount => amount > 0);
                return hasExistingData || hasNewData;
            })
            .sort((a, b) => a - b); // Ordenar meses numéricamente

        return allMonths;
    };

    // Función para obtener todos los códigos únicos (existentes y nuevos)
    const getUniqueCodes = (month) => {
        const existingCodes = Object.keys(existingData[month] || {});
        const newCodes = Object.keys(newData[month] || {})
            .filter(code => newData[month][code] > 0);
        return [...new Set([...existingCodes, ...newCodes])];
    };

    // Obtener los meses relevantes
    const relevantMonths = getRelevantMonths();

    return (
        <div className='dialog-overlay'>
            <section className='confirmation-dialog flex'>
                <span className='flex'>
                    <img src={warning} className='icon' alt='Icono de advertencia' />
                    <p>Ya existen gastos registrados para los siguientes períodos:</p>
                </span>
                {relevantMonths.map(month => (
                    <div key={month} className='table-container flex'>
                        <p className='months'>{months[month - 1]}</p>
                        <table className="amounts-table">
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Monto Existente</th>
                                    <th>Nuevo Monto</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getUniqueCodes(month).map(code => {
                                    const existingAmount = existingData[month]?.[code] || 0;
                                    const newAmount = newData[month]?.[code] || 0;
                                    
                                    if (existingAmount > 0 || newAmount > 0) {
                                        return (
                                            <tr key={code}>
                                                <td>{code}</td>
                                                <td>{formatCurrency(existingAmount)}</td>
                                                <td>
                                                    {newAmount > 0 
                                                        ? formatCurrency(newAmount)
                                                        : <span className="no-change">No modificado</span>
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    }
                                    return null;
                                })}
                            </tbody>
                        </table>
                        <div className="table-footer flex">
                            <p className="info-text">
                                * Solo se modificarán los montos de los códigos ingresados. 
                                Los códigos marcados como "No modificado" mantendrán sus valores actuales.
                            </p>
                        </div>
                    </div>
                ))}
                <p className="confirmation-question">¿Qué deseas hacer con estos nuevos montos?</p>
                <article className="dialog-buttons flex">
                    <button onClick={onSum} className="btn-primary">
                        Agregar a los valores existentes
                    </button>
                    <button onClick={onOverwrite} className="btn-warning">
                        Sobreescribir montos ingresados
                    </button>
                    <button onClick={onCancel} className="btn-secondary">
                        Cancelar
                    </button>
                </article>
            </section>
        </div>
    );
};
